module.exports = __webpack_public_path__ + "img/gallery_layout4.9eb79f5d.png";